import { ExpandLess, ExpandMore } from '@mui/icons-material';
import DevicesIcon from '@mui/icons-material/Devices';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IRegistration {
  isAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const RegistrationMenu = (props: IRegistration) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.registration">Registration</Translate>} placement="right">
        <ListItemButton
          id="registration-button"
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: props.isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <DevicesIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.registration">Registration</Translate>}
            primaryTypographyProps={{
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        {props.isAdmin && (
          <List component="div" disablePadding onClick={() => props.setOpen(false)}>
            <MenuItem icon="caret-right" to="/sensor-hardware">
              <Translate contentKey="global.menu.entities.sensorHardware" />
            </MenuItem>
            <MenuItem icon="caret-right" to="/device">
              <Translate contentKey="global.menu.entities.device" />
            </MenuItem>
            <MenuItem icon="caret-right" to="/device-truck-implement">
              <Translate contentKey="global.menu.entities.deviceTruckImplement" />
            </MenuItem>
            <MenuItem icon="caret-right" to="/sensor">
              <Translate contentKey="global.menu.entities.sensor" />
            </MenuItem>
            <MenuItem icon="caret-right" to="/device-sensor">
              <Translate contentKey="global.menu.entities.deviceSensor" />
            </MenuItem>
          </List>
        )}
      </Collapse>
    </>
  );
};
